const prefix = 'pathwayuIntegration/';

export const FETCH_ALL_HUBS = `${prefix}FETCH_ALL_HUBS`;
export const FETCH_ALL_COMPANIES = `${prefix}FETCH_ALL_COMPANIES`;
export const CREATE_INTEGRATION = `${prefix}CREATE_INTEGRATION`;
export const SET_PATHWAYU_INTEGRATION = `${prefix}SET_PATHWAYU_INTEGRATION`;
export const INTEGRATION_SUCCESS = `${prefix}INTEGRATION_SUCCESS`;
export const FETCH_MIGRATION_STATUS = `${prefix}FETCH_MIGRATION_STATUS`;
export const START_MIGRATION_POLLING = 'START_MIGRATION_POLLING';
export const STOP_MIGRATION_POLLING = 'STOP_MIGRATION_POLLING';
export const CLEAR_FAILED_MIGRATION = `${prefix}CLEAR_FAILED_MIGRATION`;

export const fetchAllHubs = () => ({ type: FETCH_ALL_HUBS });
export const fetchAllCompanies = () => ({ type: FETCH_ALL_COMPANIES });
export const createIntegration = data => ({
  type: CREATE_INTEGRATION,
  data,
});

export const integrationSuccess = () => ({ type: INTEGRATION_SUCCESS });
export const fetchMigrationStatus = hubId => ({
  type: FETCH_MIGRATION_STATUS,
  hubId,
});

export const startMigrationPolling = () => ({ type: START_MIGRATION_POLLING });
export const stopMigrationPolling = () => ({ type: STOP_MIGRATION_POLLING });

export const clearFailedMigration = hubId => ({
  type: CLEAR_FAILED_MIGRATION,
  hubId,
});
